import Vue from 'vue'
import App from './App.vue'
//import axios from 'axios'

import { 
  MdApp, MdMenu, MdDrawer, MdToolbar, MdList, MdTabs, MdContent, MdField, 
  MdCheckbox, MdDatepicker, MdButton, MdSnackbar, MdTable, MdDialog, MdRipple
} from 'vue-material/dist/components' 
//import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/black-green-light.css' // This line here^

//Vue.use(VueMaterial)

Vue.use(MdApp)
Vue.use(MdMenu)
Vue.use(MdDrawer)
Vue.use(MdToolbar)
Vue.use(MdTabs)
Vue.use(MdContent)
Vue.use(MdList)
Vue.use(MdField)
Vue.use(MdCheckbox)
Vue.use(MdDatepicker)
Vue.use(MdButton)
Vue.use(MdSnackbar)
Vue.use(MdTable)
Vue.use(MdDialog)
Vue.use(MdRipple)

Vue.material.locale.dateFormat = 'dd.MM.yyyy'
Vue.material.locale.startYear = 2019
Vue.material.locale.endYear = 2030
Vue.material.locale.days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
Vue.material.locale.shortDays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
Vue.material.locale.shorterDays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
Vue.material.locale.months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
Vue.material.locale.shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
Vue.material.locale.shorterMonths = ['J', 'F', 'Mä', 'Ap', 'Ma', 'Jun', 'Jul', 'Au', 'S', 'O', 'N', 'D'],
// `0` stand for Sunday, `1` stand for Monday
Vue.material.locale.firstDayOfAWeek = 1

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  mounted () {
    /*
    axios
      .get('http:/192.168.1.106:1848/')
      .then((response) => {
        alert(String(response));
        this.info = response;
      });*/
      }
  }
).$mount('#app')
